import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
interface WeekAccordionProps {
  week: string;
  title: string;
  children: React.ReactNode;
  defaultOpen?: boolean;
}
export function WeekAccordion({
  week,
  title,
  children,
  defaultOpen = false
}: WeekAccordionProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  return <div className="mb-6 border border-gray-200 rounded-lg shadow-sm overflow-hidden" data-id="element-449">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full flex items-center justify-between p-5 bg-white hover:bg-gray-50 transition-colors" data-id="element-450">
        <div className="flex items-center" data-id="element-451">
          <div className="flex items-center justify-center w-12 h-12 rounded-full bg-teal-100 mr-4" data-id="element-452">
            <span className="font-bold text-teal-700" data-id="element-453">{week}</span>
          </div>
          <h3 className="text-xl font-semibold text-gray-800 text-left" data-id="element-454">
            {title}
          </h3>
        </div>
        <div className="text-teal-600" data-id="element-455">
          {isOpen ? <ChevronUpIcon size={24} data-id="element-456" /> : <ChevronDownIcon size={24} data-id="element-457" />}
        </div>
      </button>
      {isOpen && <div className="p-5 bg-white border-t border-gray-200" data-id="element-458">{children}</div>}
    </div>;
}